function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 40.75,
  cy: 40,
  r: 40,
  fill: "#C4C4C4"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 40.75,
  cy: 40,
  r: 40,
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M0.75 -14.9768L80.75 -15L80.7442 11.6929C78.3171 14.9945 74.2472 16.3875 68.5343 15.8719C59.9649 15.0988 44.9198 8.13749 27.9438 8.13749C16.6264 8.13749 7.56184 11.8028 0.75 19.1333V-14.9768Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M45.8484 49.3536C45.7848 49.3528 45.7218 49.3645 45.6629 49.3883C45.604 49.4121 45.5504 49.4473 45.5052 49.4919C45.46 49.5366 45.4241 49.5897 45.3996 49.6484C45.3752 49.707 45.3625 49.7699 45.3625 49.8334C45.3625 49.897 45.3752 49.9598 45.3996 50.0184C45.4241 50.077 45.46 50.1302 45.5052 50.1748C45.5504 50.2195 45.604 50.2547 45.6629 50.2785C45.7218 50.3022 45.7848 50.3141 45.8484 50.3133H46.3151C46.3786 50.3141 46.4417 50.3022 46.5006 50.2785C46.5595 50.2547 46.6131 50.2195 46.6583 50.1748C46.7034 50.1302 46.7393 50.077 46.7638 50.0184C46.7883 49.9598 46.8009 49.897 46.8009 49.8334C46.8009 49.7699 46.7883 49.707 46.7638 49.6484C46.7393 49.5897 46.7034 49.5366 46.6583 49.4919C46.6131 49.4473 46.5595 49.4121 46.5006 49.3883C46.4417 49.3645 46.3786 49.3528 46.3151 49.3536H45.8484Z",
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M43.4482 49.3536C43.3847 49.3528 43.3217 49.3645 43.2627 49.3883C43.2038 49.4121 43.1502 49.4473 43.1051 49.4919C43.0599 49.5366 43.024 49.5897 42.9995 49.6484C42.975 49.707 42.9624 49.7699 42.9624 49.8334C42.9624 49.897 42.975 49.9598 42.9995 50.0184C43.024 50.077 43.0599 50.1302 43.1051 50.1748C43.1502 50.2195 43.2038 50.2547 43.2627 50.2785C43.3217 50.3022 43.3847 50.3141 43.4482 50.3133H43.915C43.9785 50.3141 44.0415 50.3022 44.1004 50.2785C44.1593 50.2547 44.2129 50.2195 44.2581 50.1748C44.3033 50.1302 44.3392 50.077 44.3637 50.0184C44.3882 49.9598 44.4008 49.897 44.4008 49.8334C44.4008 49.7699 44.3882 49.707 44.3637 49.6484C44.3392 49.5897 44.3033 49.5366 44.2581 49.4919C44.2129 49.4473 44.1593 49.4121 44.1004 49.3883C44.0415 49.3645 43.9785 49.3528 43.915 49.3536H43.4482Z",
  fill: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M44.875 50.3135C44.8118 50.3142 44.7494 50.3274 44.6913 50.3524C44.6332 50.3773 44.5807 50.4134 44.5366 50.4586C44.4925 50.5039 44.4579 50.5574 44.4345 50.6162C44.4112 50.6749 44.3997 50.7376 44.4007 50.8008V51.2677C44.3998 51.3312 44.4115 51.3943 44.4353 51.4533C44.459 51.5123 44.4942 51.5661 44.5388 51.6114C44.5835 51.6567 44.6367 51.6926 44.6954 51.7171C44.754 51.7416 44.817 51.7543 44.8806 51.7543C44.9442 51.7543 45.0071 51.7416 45.0658 51.7171C45.1245 51.6926 45.1777 51.6567 45.2223 51.6114C45.267 51.5661 45.3022 51.5123 45.3259 51.4533C45.3496 51.3943 45.3614 51.3312 45.3605 51.2677V50.8008C45.3615 50.7367 45.3496 50.6731 45.3256 50.6136C45.3016 50.5542 45.2659 50.5001 45.2206 50.4547C45.1754 50.4092 45.1214 50.3733 45.0621 50.349C45.0027 50.3248 44.9391 50.3128 44.875 50.3135Z",
  fill: "black"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M44.875 47.9139C44.8118 47.9146 44.7494 47.9278 44.6913 47.9527C44.6332 47.9776 44.5807 48.0137 44.5366 48.059C44.4925 48.1043 44.4579 48.1579 44.4345 48.2166C44.4112 48.2753 44.3997 48.3381 44.4007 48.4013V48.868C44.3998 48.9316 44.4115 48.9947 44.4353 49.0538C44.459 49.1128 44.4942 49.1664 44.5388 49.2117C44.5835 49.257 44.6367 49.293 44.6954 49.3176C44.754 49.3421 44.817 49.3546 44.8806 49.3546C44.9442 49.3546 45.0071 49.3421 45.0658 49.3176C45.1245 49.293 45.1777 49.257 45.2223 49.2117C45.267 49.1664 45.3022 49.1128 45.3259 49.0538C45.3496 48.9947 45.3614 48.9316 45.3605 48.868V48.4013C45.3615 48.3372 45.3496 48.2734 45.3256 48.214C45.3016 48.1545 45.2659 48.1004 45.2206 48.055C45.1754 48.0096 45.1214 47.9736 45.0621 47.9494C45.0027 47.9251 44.9391 47.9131 44.875 47.9139Z",
  fill: "black"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M40.0822 51.2738C39.9549 51.2738 39.8328 51.2232 39.7429 51.1332C39.6529 51.0432 39.6023 50.9211 39.6023 50.7939C39.6023 50.6666 39.6529 50.5444 39.7429 50.4544C39.8328 50.3645 39.9549 50.314 40.0822 50.314C40.2095 50.314 40.3315 50.3645 40.4215 50.4544C40.5115 50.5444 40.5621 50.6666 40.5621 50.7939C40.5621 50.9211 40.5115 51.0432 40.4215 51.1332C40.3315 51.2232 40.2095 51.2738 40.0822 51.2738Z",
  fill: "black"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M53.0462 45.5088C52.9826 45.5079 52.9194 45.5196 52.8604 45.5433C52.8013 45.567 52.7475 45.6022 52.7022 45.6469C52.6569 45.6915 52.6209 45.7447 52.5963 45.8034C52.5717 45.8621 52.5591 45.9251 52.5591 45.9887C52.5591 46.0524 52.5717 46.1154 52.5963 46.1741C52.6209 46.2327 52.6569 46.286 52.7022 46.3307C52.7475 46.3754 52.8013 46.4105 52.8604 46.4342C52.9194 46.4579 52.9826 46.4696 53.0462 46.4686H53.513C53.5766 46.4696 53.6398 46.4579 53.6988 46.4342C53.7579 46.4105 53.8117 46.3754 53.857 46.3307C53.9023 46.286 53.9383 46.2327 53.9629 46.1741C53.9875 46.1154 54.0001 46.0524 54.0001 45.9887C54.0001 45.9251 53.9875 45.8621 53.9629 45.8034C53.9383 45.7447 53.9023 45.6915 53.857 45.6469C53.8117 45.6022 53.7579 45.567 53.6988 45.5433C53.6398 45.5196 53.5766 45.5079 53.513 45.5088H53.0462Z",
  fill: "black"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M50.647 45.5088C50.5834 45.5079 50.5202 45.5196 50.4612 45.5433C50.4021 45.567 50.3484 45.6022 50.303 45.6469C50.2577 45.6915 50.2217 45.7447 50.1971 45.8034C50.1726 45.8621 50.1599 45.9251 50.1599 45.9887C50.1599 46.0524 50.1726 46.1154 50.1971 46.1741C50.2217 46.2327 50.2577 46.286 50.303 46.3307C50.3484 46.3754 50.4021 46.4105 50.4612 46.4342C50.5202 46.4579 50.5834 46.4696 50.647 46.4686H51.1138C51.1774 46.4696 51.2406 46.4579 51.2997 46.4342C51.3587 46.4105 51.4125 46.3754 51.4578 46.3307C51.5031 46.286 51.5391 46.2327 51.5637 46.1741C51.5883 46.1154 51.6009 46.0524 51.6009 45.9887C51.6009 45.9251 51.5883 45.8621 51.5637 45.8034C51.5391 45.7447 51.5031 45.6915 51.4578 45.6469C51.4125 45.6022 51.3587 45.567 51.2997 45.5433C51.2406 45.5196 51.1774 45.5079 51.1138 45.5088H50.647Z",
  fill: "black"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M52.0732 46.4688C51.9459 46.4703 51.8244 46.5223 51.7355 46.6134C51.6466 46.7044 51.5974 46.827 51.5989 46.9543V47.421C51.598 47.4846 51.6098 47.5478 51.6335 47.6068C51.6572 47.6658 51.6924 47.7196 51.7371 47.7649C51.7817 47.8102 51.8349 47.8461 51.8936 47.8706C51.9523 47.8951 52.0152 47.9078 52.0788 47.9078C52.1424 47.9078 52.2054 47.8951 52.264 47.8706C52.3227 47.8461 52.3759 47.8102 52.4206 47.7649C52.4652 47.7196 52.5004 47.6658 52.5241 47.6068C52.5478 47.5478 52.5596 47.4846 52.5587 47.421V46.9543C52.5594 46.8904 52.5474 46.8269 52.5233 46.7677C52.4991 46.7084 52.4634 46.6546 52.4182 46.6094C52.3729 46.5641 52.3191 46.5283 52.2599 46.5042C52.2006 46.4801 52.1372 46.468 52.0732 46.4688Z",
  fill: "black"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M52.0732 44.0691C51.9459 44.0706 51.8245 44.1225 51.7355 44.2136C51.6466 44.3046 51.5974 44.4273 51.5989 44.5546V45.0214C51.598 45.085 51.6098 45.148 51.6335 45.207C51.6572 45.266 51.6924 45.3198 51.7371 45.3651C51.7817 45.4104 51.8349 45.4463 51.8936 45.4708C51.9523 45.4954 52.0152 45.508 52.0788 45.508C52.1424 45.508 52.2054 45.4954 52.264 45.4708C52.3227 45.4463 52.3759 45.4104 52.4206 45.3651C52.4652 45.3198 52.5004 45.266 52.5241 45.207C52.5478 45.148 52.5596 45.085 52.5587 45.0214V44.5546C52.5594 44.4906 52.5474 44.4272 52.5233 44.3679C52.4991 44.3087 52.4634 44.2548 52.4182 44.2096C52.3729 44.1644 52.3191 44.1287 52.2599 44.1045C52.2006 44.0804 52.1372 44.0684 52.0732 44.0691Z",
  fill: "black"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M48.7206 48.3941C48.5933 48.3941 48.4713 48.3435 48.3813 48.2535C48.2913 48.1635 48.2407 48.0415 48.2407 47.9142C48.2407 47.7869 48.2913 47.6649 48.3813 47.5749C48.4713 47.4849 48.5933 47.4343 48.7206 47.4343C48.8479 47.4343 48.9699 47.4849 49.0599 47.5749C49.1499 47.6649 49.2005 47.7869 49.2005 47.9142C49.2005 48.0415 49.1499 48.1635 49.0599 48.2535C48.9699 48.3435 48.8479 48.3941 48.7206 48.3941Z",
  fill: "black"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M33.4799 26.119C33.3526 26.119 33.2306 26.0684 33.1406 25.9784C33.0506 25.8884 33 25.7663 33 25.6391C33 25.5118 33.0506 25.3898 33.1406 25.2998C33.2306 25.2098 33.3526 25.1592 33.4799 25.1592C33.6072 25.1592 33.7292 25.2098 33.8192 25.2998C33.9092 25.3898 33.9598 25.5118 33.9598 25.6391C33.9598 25.7663 33.9092 25.8884 33.8192 25.9784C33.7292 26.0684 33.6072 26.119 33.4799 26.119Z",
  fill: "black"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M38.279 23.9598C38.4062 23.9598 38.5283 23.9092 38.6183 23.8192C38.7083 23.7292 38.7588 23.6072 38.7588 23.4799C38.7588 23.4169 38.7464 23.3545 38.7223 23.2962C38.6982 23.238 38.6629 23.1852 38.6183 23.1406C38.5737 23.096 38.5208 23.0607 38.4626 23.0365C38.4044 23.0124 38.342 23 38.279 23C38.2159 23 38.1535 23.0124 38.0953 23.0365C38.0371 23.0607 37.9842 23.096 37.9396 23.1406C37.8951 23.1852 37.8597 23.238 37.8356 23.2962C37.8115 23.3545 37.7991 23.4169 37.7991 23.4799C37.7991 23.6072 37.8496 23.7292 37.9396 23.8192C38.0296 23.9092 38.1517 23.9598 38.279 23.9598Z",
  fill: "black"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M28.5717 23.4397C28.5082 23.439 28.4452 23.4508 28.3863 23.4746C28.3274 23.4984 28.2738 23.5336 28.2286 23.5782C28.1834 23.6229 28.1475 23.676 28.123 23.7346C28.0985 23.7933 28.0859 23.8561 28.0859 23.9196C28.0859 23.9831 28.0985 24.046 28.123 24.1046C28.1475 24.1632 28.1834 24.2164 28.2286 24.261C28.2738 24.3057 28.3274 24.341 28.3863 24.3648C28.4452 24.3885 28.5082 24.4003 28.5717 24.3995H29.0385C29.102 24.4003 29.165 24.3885 29.224 24.3648C29.2829 24.341 29.3365 24.3057 29.3816 24.261C29.4268 24.2164 29.4627 24.1632 29.4872 24.1046C29.5117 24.046 29.5243 23.9831 29.5243 23.9196C29.5243 23.8561 29.5117 23.7933 29.4872 23.7346C29.4627 23.676 29.4268 23.6229 29.3816 23.5782C29.3365 23.5336 29.2829 23.4984 29.224 23.4746C29.165 23.4508 29.102 23.439 29.0385 23.4397H28.5717Z",
  fill: "black"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M30.9716 23.4397C30.9081 23.439 30.8451 23.4508 30.7862 23.4746C30.7273 23.4984 30.6737 23.5336 30.6285 23.5782C30.5833 23.6229 30.5474 23.676 30.5229 23.7346C30.4984 23.7933 30.4858 23.8561 30.4858 23.9196C30.4858 23.9831 30.4984 24.046 30.5229 24.1046C30.5474 24.1632 30.5833 24.2164 30.6285 24.261C30.6737 24.3057 30.7273 24.341 30.7862 24.3648C30.8451 24.3885 30.9081 24.4003 30.9716 24.3995H31.4384C31.5019 24.4003 31.565 24.3885 31.6239 24.3648C31.6828 24.341 31.7364 24.3057 31.7815 24.261C31.8267 24.2164 31.8626 24.1632 31.8871 24.1046C31.9116 24.046 31.9242 23.9831 31.9242 23.9196C31.9242 23.8561 31.9116 23.7933 31.8871 23.7346C31.8626 23.676 31.8267 23.6229 31.7815 23.5782C31.7364 23.5336 31.6828 23.4984 31.6239 23.4746C31.565 23.4508 31.5019 23.439 31.4384 23.4397H30.9716Z",
  fill: "black"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M29.9985 24.3997C29.9353 24.4004 29.8729 24.4136 29.8148 24.4385C29.7568 24.4635 29.7042 24.4996 29.6601 24.5449C29.6161 24.5902 29.5814 24.6437 29.5581 24.7025C29.5347 24.7612 29.5232 24.8239 29.5242 24.8871V25.3538C29.5233 25.4174 29.5351 25.4806 29.5588 25.5396C29.5825 25.5986 29.6177 25.6523 29.6624 25.6976C29.707 25.7428 29.7602 25.7788 29.8189 25.8034C29.8776 25.8279 29.9405 25.8406 30.0041 25.8406C30.0677 25.8406 30.1307 25.8279 30.1893 25.8034C30.248 25.7788 30.3012 25.7428 30.3459 25.6976C30.3905 25.6523 30.4257 25.5986 30.4494 25.5396C30.4732 25.4806 30.4849 25.4174 30.484 25.3538V24.8871C30.485 24.823 30.4731 24.7593 30.4491 24.6998C30.4251 24.6403 30.3894 24.5864 30.3441 24.5409C30.2989 24.4955 30.245 24.4596 30.1856 24.4353C30.1262 24.4111 30.0626 24.3989 29.9985 24.3997Z",
  fill: "black"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M29.9985 22C29.9353 22.0008 29.8729 22.0141 29.8148 22.039C29.7568 22.0639 29.7042 22.1 29.6601 22.1453C29.6161 22.1906 29.5814 22.2441 29.5581 22.3028C29.5347 22.3615 29.5232 22.4243 29.5242 22.4875V22.9542C29.5233 23.0178 29.5351 23.0809 29.5588 23.1399C29.5825 23.1989 29.6177 23.2527 29.6624 23.298C29.707 23.3433 29.7602 23.3792 29.8189 23.4037C29.8776 23.4283 29.9405 23.4409 30.0041 23.4409C30.0677 23.4409 30.1307 23.4283 30.1893 23.4037C30.248 23.3792 30.3012 23.3433 30.3459 23.298C30.3905 23.2527 30.4257 23.1989 30.4494 23.1399C30.4732 23.0809 30.4849 23.0178 30.484 22.9542V22.4875C30.485 22.4233 30.4731 22.3597 30.4491 22.3003C30.4251 22.2408 30.3894 22.1867 30.3441 22.1413C30.2989 22.0959 30.245 22.0599 30.1856 22.0357C30.1262 22.0114 30.0626 21.9993 29.9985 22Z",
  fill: "black"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M33.8439 23.4403C33.9069 23.4403 33.9693 23.4278 34.0276 23.4037C34.0858 23.3796 34.1387 23.3442 34.1832 23.2997C34.2278 23.2551 34.2632 23.2021 34.2873 23.1439C34.3114 23.0857 34.3238 23.0233 34.3238 22.9603C34.3238 22.833 34.2732 22.7109 34.1832 22.6209C34.0932 22.531 33.9712 22.4805 33.8439 22.4805C33.7166 22.4805 33.5946 22.531 33.5046 22.6209C33.4146 22.7109 33.364 22.833 33.364 22.9603C33.364 23.0233 33.3764 23.0857 33.4005 23.1439C33.4246 23.2021 33.46 23.2551 33.5046 23.2997C33.5491 23.3442 33.602 23.3796 33.6602 23.4037C33.7185 23.4278 33.7809 23.4403 33.8439 23.4403Z",
  fill: "black"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M35.7631 24.8798C35.8904 24.8798 36.0124 24.8294 36.1024 24.7394C36.1924 24.6494 36.243 24.5272 36.243 24.3999C36.243 24.2727 36.1924 24.1506 36.1024 24.0606C36.0124 23.9707 35.8904 23.9202 35.7631 23.9202C35.6358 23.9202 35.5138 23.9707 35.4238 24.0606C35.3338 24.1506 35.2832 24.2727 35.2832 24.3999C35.2832 24.5272 35.3338 24.6494 35.4238 24.7394C35.5138 24.8294 35.6358 24.8798 35.7631 24.8798Z",
  fill: "black"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M36.5778 41.1779L36.5556 41.2668L35.0667 41.7112C34.6445 41.8445 34.1556 43.089 33.7778 45.0445C35.0445 45.8001 36.5112 46.2001 38.0001 46.2001C38.1778 46.2001 38.3778 46.2001 38.5556 46.1779C39.8445 46.089 41.1334 45.7112 42.2445 45.0445C41.8667 43.1112 41.3778 41.8223 40.9556 41.7112L39.4667 41.2668L39.4445 41.1779C39.4223 41.1112 39.3778 41.0445 39.2889 41.0001L39.1112 40.889L39.2223 40.7556C39.3556 40.6223 39.4445 40.489 39.4889 40.4001C39.6667 40.1556 39.8001 39.889 39.8889 39.6223C39.9334 39.5112 39.9778 39.4001 40.0223 39.289L40.0445 39.2445L40.0889 39.2223C40.2001 39.1334 40.2445 39.0223 40.2445 38.889V38.4445C40.2445 38.3556 40.2223 38.2668 40.1556 38.1779L40.1334 38.1334V37.4668C40.1334 36.4668 39.3112 35.6445 38.3112 35.6445H37.6667C36.6667 35.6445 35.8445 36.4668 35.8445 37.4668V38.1334L35.8223 38.1779C35.7778 38.2445 35.7334 38.3556 35.7334 38.4445V38.889C35.7334 39.0223 35.8001 39.1556 35.8889 39.2223L35.9334 39.2445L35.9556 39.289C35.9778 39.4001 36.0223 39.5112 36.0667 39.6001C36.1778 39.8668 36.3112 40.1334 36.4889 40.3779C36.5778 40.5112 36.6667 40.6223 36.7556 40.7334L36.8667 40.8668L36.7112 40.9779C36.6667 41.0668 36.6001 41.1112 36.5778 41.1779Z",
  fill: "black"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M33.0222 44.5556C33.0667 44.3111 33.1334 44.0667 33.2 43.8C33.7556 41.5111 34.3334 41.0667 34.8222 40.9111L35.6667 40.6667C35.5334 40.4445 35.4 40.2 35.3111 39.9556C35.2889 39.8889 35.2445 39.8 35.2222 39.7334L34.3111 39.4667L34.2889 39.3778C34.2667 39.3111 34.2222 39.2445 34.1334 39.2L33.9778 39.0667L34.0889 38.9334C34.1778 38.8223 34.2667 38.7111 34.3556 38.5778C34.5334 38.3334 34.6667 38.0667 34.7556 37.8223C34.8 37.7111 34.8445 37.6 34.8889 37.4889L34.9111 37.4445L34.9556 37.4223C35.0667 37.3334 35.1111 37.2223 35.1111 37.0889V36.6445C35.1111 36.5556 35.0889 36.4667 35.0222 36.3778L35 36.3334V35.6667C35 34.6667 34.1778 33.8445 33.1778 33.8445H32.5334C31.5334 33.8445 30.7111 34.6667 30.7111 35.6667V36.3334L30.6889 36.3778C30.6445 36.4445 30.6 36.5556 30.6 36.6445V37.0889C30.6 37.2223 30.6667 37.3556 30.7556 37.4223L30.8 37.4445L30.8222 37.4889C30.8445 37.6 30.8889 37.7111 30.9556 37.8C31.0667 38.0667 31.2 38.3334 31.3778 38.5778C31.4667 38.7111 31.5556 38.8223 31.6445 38.9334L31.7556 39.0667L31.6 39.1778C31.5111 39.2445 31.4667 39.2889 31.4445 39.3556L31.4222 39.4445L29.9334 39.8889H29.9111C30.3778 41.7556 31.4889 43.4 33.0222 44.5556Z",
  fill: "black"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M43.4444 33.8223H42.7999C41.7999 33.8223 40.9777 34.6445 40.9777 35.6445V36.3112L40.9555 36.3556C40.911 36.4445 40.8888 36.5334 40.8888 36.6223V37.0667C40.8888 37.2 40.9555 37.3334 41.0444 37.4L41.0888 37.4223L41.111 37.4667C41.1555 37.5778 41.1777 37.6889 41.2221 37.7778C41.3333 38.0445 41.4666 38.3112 41.6444 38.5556C41.711 38.6445 41.7999 38.7778 41.911 38.9112L42.0221 39.0445L41.8666 39.1556C41.7777 39.2223 41.7333 39.2667 41.711 39.3334L41.6888 39.4223L40.7777 39.6889C40.7555 39.7778 40.711 39.8445 40.6888 39.9334C40.5999 40.1556 40.4666 40.4 40.3333 40.6445L41.1777 40.8889C41.6666 41.0223 42.2444 41.4889 42.7999 43.7334C42.8666 44 42.9333 44.2667 42.9777 44.5334C43.4444 44.1778 43.8888 43.7778 44.2666 43.3334C45.1333 42.3334 45.7777 41.1334 46.0888 39.8667H46.0666L44.5777 39.4223L44.5555 39.3334C44.5333 39.2667 44.4888 39.2 44.3999 39.1556L44.2444 39.0667L44.3777 38.9334C44.4666 38.8223 44.5555 38.7112 44.6444 38.5778C44.8221 38.3334 44.9555 38.0667 45.0444 37.8223C45.0888 37.7112 45.1333 37.6 45.1777 37.4889L45.1999 37.4445L45.2444 37.4223C45.3555 37.3334 45.3999 37.2223 45.3999 37.0889V36.6445C45.3999 36.5556 45.3777 36.4667 45.311 36.3778L45.2888 36.3334V35.6667C45.2666 34.6445 44.4666 33.8223 43.4444 33.8223Z",
  fill: "black"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M32.4667 30.7333L31.7778 30.7111C33.5111 29.2222 35.7111 28.4 38 28.4C40.2889 28.4 42.4889 29.2222 44.2222 30.7111L43.5333 30.7333L43.9555 31.1333L44.9333 31.0889L44.8889 30.1333L44.4667 29.7333L44.4889 30.4222C42.6889 28.8444 40.4 28 38 28C35.6 28 33.3111 28.8444 31.5111 30.4L31.5333 29.7111L31.1111 30.1333L31.0667 31.1111L32.0444 31.1556L32.4667 30.7333Z",
  fill: "black"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M46.9778 33.5334L46.4889 33.7779C47.1333 35.089 47.4667 36.489 47.4667 37.9334C47.4667 43.1557 43.2222 47.4001 38 47.4001C32.7778 47.4001 28.5333 43.1557 28.5333 37.9334C28.5333 36.489 28.8667 35.089 29.5111 33.7779L29.0222 33.5334C28.3333 34.9334 28 36.4001 28 37.9112C28 43.4223 32.4889 47.9112 38 47.9112C43.5111 47.9112 48 43.4223 48 37.9112C48 36.4001 47.6667 34.9334 46.9778 33.5334Z",
  fill: "black"
});

var SvgManage = function SvgManage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 81,
    height: 80
  }, _ref2), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, _ref3, /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -15,
    width: 81,
    height: 35
  }, _ref4), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.75 13.4673V18.4614L40.75 15.9644L0.75 13.4673Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8058 15.9268L40.8156 15.9189L40.7979 15.9207L40.7917 15.9251L40.8058 15.9268Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9001 15.9324L80.75 18.4197V13.4275L41.0245 15.9058L40.9001 15.9324Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7836 15.9254L40.7873 15.9209L40.7766 15.9218L40.7749 15.9245L40.7836 15.9254Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.758 15.9224H40.7527V15.9243H40.758V15.9224Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8506 15.9298L40.8958 15.9138L40.8408 15.9172L40.8203 15.9279L40.8506 15.9298Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7677 15.9199H40.7651V15.927H40.7677V15.9199Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 24.4789V29.831L40.75 15.9644L0.75 24.4789Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.75 15.9642L40.9002 15.9322L40.8505 15.9297L40.75 15.9642Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0244 15.9057L80.75 7.44978V2.09863L40.8958 15.9138L41.0244 15.9057Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8958 15.9139L40.8503 15.9299L40.9 15.9324L41.0244 15.9058L40.8958 15.9139Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8946 31.6591L40.75 15.9644L10.5713 31.6591H17.8946Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8406 15.917L80.75 -4.83837V-11.5034L40.8157 15.919L40.8406 15.917Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8059 15.927L40.75 15.9643L40.8202 15.9279L40.8059 15.927Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8202 15.9279L40.8407 15.9172L40.816 15.9192L40.8062 15.9271L40.8202 15.9279Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3685 31.6591L40.7501 15.9644L23.7344 31.6591H27.3685Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.798 15.9207L80.75 -20.9293V-25.6392H76.2224L40.7874 15.9207H40.798Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7837 15.9253L40.75 15.9643L40.7918 15.9253H40.7837Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7918 15.9254L40.798 15.9209H40.7873L40.7837 15.9254H40.7918Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2054 31.6591L40.7499 15.9644L30.7866 31.6591H33.2054Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7766 15.9215L67.1586 -25.6392H60.7523L40.7695 15.9215H40.7766Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7686 15.9243L40.75 15.9642L40.775 15.9243H40.7686Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7749 15.9199H40.7715V15.927H40.7749V15.9199Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6613 31.6591L40.75 15.9644L35.7202 31.6591H37.6613Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7631 15.9224L54.0835 -25.6392H48.9366L40.7578 15.9224H40.7631Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7579 15.9243L40.75 15.9642L40.7632 15.9243H40.7579Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7615 15.9209H40.7598V15.9262H40.7615V15.9209Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6571 31.6591L40.75 15.9644L39.844 31.6591H41.6571Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7525 15.9243L40.7499 15.9235L40.7525 15.9224L43.1502 -25.6392H38.3506L40.7499 15.9642L40.7525 15.9243Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.75 15.9234L40.7524 15.9242V15.9224L40.75 15.9234Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7806 31.6591L40.75 15.9644L43.8386 31.6591H45.7806Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5641 -25.6392H27.4172L40.7499 15.9642L32.5641 -25.6392Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7125 31.6591L40.75 15.9644L48.2954 31.6591H50.7125Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7496 -25.6392H14.3413L40.7501 15.9642L20.7496 -25.6392Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7665 31.6591L40.75 15.9644L54.1307 31.6591H57.7665Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.27774 -25.6392H0.75V-20.9302L40.75 15.9642L5.27774 -25.6392Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9279 31.6591L40.75 15.9644L63.6055 31.6591H70.9279Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 -11.5034V-4.83837L40.75 15.9642L0.75 -11.5034Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.75 29.831V24.4789L40.75 15.9644L80.75 29.831Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 2.09766V7.44968L40.75 15.9642L0.75 2.09766Z",
    style: {
      fill: "var(--color-primary)"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 45,
    r: 12,
    style: {
      fill: "var(--color-primary)"
    }
  }), _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgManage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/manage.46110c2b.svg";
export { ForwardRef as ReactComponent };